import { Navigate } from 'react-router-dom';
import { canAccessModule } from '../../platform/security/moduleAccess';

export default function RestrictedRoute({ children, moduleId, user, tenantConfig }) {
  const hasAccess = canAccessModule(user, moduleId, tenantConfig);

  if (!hasAccess) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
